/**
 * It's important that these are all Start Case, it allows us to use kebab case and start case to manage categories in the url
 */
export enum SearchCategoryType {
  Backyard = 'Backyards',
  HotTubs = 'Hot Tubs',
  Indoors = 'Indoors',
  Paddle = 'Paddle',
  Parties = 'Parties',
  Racquet = 'Racquet',
  Boats = 'Boats',
  Homes = 'Homes',

  // SPACE TYPES
  All = 'All',
  Hoop = 'Hoops',
  Discover = 'Discover',

  // USE CASES
  Budget = 'Budget',
  Family = 'Family',
  Heated = 'Heated',
  Pets = 'Pets',
  Vip = 'Vip',
}

export enum SearchCategoryLabel {
  Yards = 'Yards',
  Indoors = 'Indoors',
  Parties = 'Parties',
  Boats = 'Boats',

  // SPACE TYPES
  All = 'All spaces',
  Pool = 'Pool',
  Homes = 'Homes',
  Home = 'Home',
  Mansions = 'Mansions',
  Pickleball = 'Pickleball',
  Tennis = 'Tennis',
  Hoops = 'Hoops',
  Discover = 'Discover',
  Igloos = 'Igloos',

  // USE CASES
  Budget = '<$45',
  Family = 'Family',
  Heated = 'Heated',
  HotTub = 'Hot Tub',
  Pets = 'Pets',
  Vip = 'VIP',
}

export enum SpaceTypeSlugs {
  All = 'all', // for eventing, should actually be undefined when sent to search
  Discover = 'discover',
  Experiences = 'experiences', // backend space type; hidden from search filters UI
  Home = 'home',
  Hoops = 'hoops',
  Pickleball = 'pickleball',
  Pool = 'pool',
  Tennis = 'tennis',
  PetParks = 'pet_park',
  Igloos = 'igloo',

  // Partnership slugs
  PC = 'pc',
  DISNEY = 'disney',
  SIMPLY = 'simply',
}

/** Default space type when none is specified in the URL on search page load. */
export const DEFAULT_SPACE_TYPE_SLUG = SpaceTypeSlugs.Pool

export const isSupportedSpaceType = (
  category: string
): category is SpaceTypeSlugs =>
  !!Object.values(SpaceTypeSlugs).find((c) => c === category)

export enum UseCaseSlugs {
  All = 'all', // for eventing, should actually be undefined when sent to search

  Backyard = 'backyard',
  Bar = 'bar',
  Budget = 'budget',
  Caves = 'cave',
  Conference = 'conference',
  Corporate = 'corporate',
  ColdPlunge = 'cold_plunge',
  Deal = 'deal',
  Dinner = 'dinner',
  EventVenue = 'event_venue',
  Family = 'family',
  FirePit = 'fire_pit',
  Grill = 'grill',
  Heated = 'heated',
  HomeGym = 'home_gym',
  HotTub = 'hot_tub',
  House = 'house',
  Indoor = 'indoor',
  Loft = 'loft',
  Luxe = 'luxe',
  Mansion = 'mansion',
  Meeting = 'meeting',
  Movie = 'movie',
  Multicourt = 'multicourt',
  New = 'new',
  Night = 'night',
  Outdoor = 'outdoor',
  Party = 'party',
  Passes = 'pass',
  Pet = 'pet',
  Photo = 'photo',
  Plunge = 'plunge',
  Pool = 'pool',
  PrivacyPlus = 'privacy_plus',
  Restaurant = 'restaurant',
  Rooftop = 'rooftop',
  SaltWater = 'salt_water',
  Saunas = 'sauna',
  Shallow = 'shallow',
  ShallowPools = 'shallow_pools',
  Sports = 'sports',
  Studio = 'studio',
  Today = 'today',
  Vip = 'vip',
  Warehouse = 'warehouse',
  Wedding = 'wedding',

  // These are unverified
  BackyardOnly = 'backyard_only',
  SelfCare = 'self_care',
}

export const isSupportedUseCase = (useCase: string): useCase is UseCaseSlugs =>
  !!Object.values(UseCaseSlugs).find((c) => c === useCase)
